import React, { useState } from 'react'
import moment from 'moment'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import AnDateTimePicker from '../../../../../../components/DateTime/DateTimePicker'
import DeliveryMethod from './DeliveryMethod'
import TreatmentOutcome from '../../TreatmentOutcome'
import TreatmentText from '../../TreatmentText'
import TreatmentSubmitModule from '../../TreatmentSubmitButton'

const Entonox = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  return (
    <Box padding={1}>
      <Grid container spacing={2} alignItems={2}>
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">Entonox Administration</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime}
            fullWidth
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
            size="small"
          />
        </Grid>
        <DeliveryMethod
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <TreatmentOutcome
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <TreatmentText
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <TreatmentSubmitModule
          moduleName="Entonox"
          moduleValues={moduleValues}
          submitModule={submitModule}
        />
      </Grid>
    </Box>
  )
}

export default Entonox
